import { ActionType } from 'typesafe-actions';
import { matchesActions } from './actions';
import { combineReducers } from 'redux';
import {
  REMOVE_SEARCH,
  SEARCH_MATCHES_FAILURE,
  SEARCH_MATCHES_REQUEST,
  SEARCH_MATCHES_SUCCESS,
} from '../../constants/matches';

import { betsMatchesReducer } from './bets/reducer';
import { MatchFromBE } from '../tips/reducer';

export type MatchesActions = ActionType<typeof matchesActions>;

export type SearchMatchesState = {
  requested: boolean;
  data: MatchFromBE[];
  isLoading: boolean;
  error: string | null;
};

export const searchMatchesReducer = combineReducers<
  SearchMatchesState,
  MatchesActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case SEARCH_MATCHES_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state: MatchFromBE[] = [], action) => {
    switch (action.type) {
      case SEARCH_MATCHES_SUCCESS:
        return action.payload.matches;
      case REMOVE_SEARCH:
        return [];
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case SEARCH_MATCHES_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case SEARCH_MATCHES_FAILURE:
        return action.payload;
      default:
        return state;
    }
  },
});

export const matchesReducer = combineReducers({
  search: searchMatchesReducer,
  bets: betsMatchesReducer,
});
